import { API_URL } from '../constants'
import { languageUtil } from './languageUtils'

function getNestedValue(obj, path) {
    return path
        .split('.')
        .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj)
}

/**
 * Reusable fetch with Accept-Language and flexible transform
 *
 * @param {string} url - endpoint relative to API_URL
 * @param {Function} setData - state setter for data
 * @param {Function} setError - state setter for error
 * @param {Function} setLoading - state setter for loading
 * @param {Object} [options] - optional config: { responseKey, transform, token }
 */
export async function fetchWithLanguage(url, setData, setError, setLoading, options = {}) {
    const { language } = languageUtil()
    const { responseKey = 'data', transform, token = false } = options

    if (setLoading) setLoading(true)

    const headers = {
        'Accept-Language': language,
    }

    if (token) {
        const authToken = token === true ? localStorage.getItem('token') : token
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`
        }
    }

    try {
        const response = await fetch(`${API_URL}/${url}`, {
            headers,
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const json = await response.json()
        const rawData = getNestedValue(json, responseKey)
        const finalData = transform ? transform(rawData) : rawData
        setData(finalData)
    } catch (err) {
        if (setError) setError(err.message)
    } finally {
        if (setLoading) setLoading(false)
    }
}
